export default __webpack_public_path__ + "static/media/privacy preserving.ed6ba6f8.png";